import { t } from "@/i18n-js/instance";
import type { SpaceGroup } from "@circle-react/types";
import { ThreeDotsDropdownV3 } from "@circle-react-shared/ThreeDotsDropdownV3";
import { Dropdown } from "@circle-react-shared/uikit/Dropdown";
import { DeleteSpaceGroupModal } from "../DeleteSpaceGroupModal";
import { useManageSpaceGroupActions } from "./useManageSpaceGroupActions";

export interface ManageSpaceGroupActionsV3Props {
  spaceGroup: SpaceGroup;
}

export const ManageSpaceGroupActionsV3 = ({
  spaceGroup,
}: ManageSpaceGroupActionsV3Props) => {
  const {
    canManage,
    shouldShowDeleteModal,
    spaceModal,
    editSpaceGroupModal,
    addSpaceGroupMemberModal,
    toggleDeleteModal,
  } = useManageSpaceGroupActions({ spaceGroup });

  if (!canManage || !spaceGroup) {
    return null;
  }

  return (
    <>
      <DeleteSpaceGroupModal
        spaceGroupId={spaceGroup.id}
        show={shouldShowDeleteModal}
        onClose={toggleDeleteModal}
      />
      <ThreeDotsDropdownV3 label={t("space_group_settings")}>
        <Dropdown.ItemWithLink
          onClick={() => editSpaceGroupModal.show({ spaceGroup })}
        >
          {t("space_groups.edit_space_group")}
        </Dropdown.ItemWithLink>
        <Dropdown.ItemWithLink
          onClick={() => spaceModal.show({ spaceGroupId: spaceGroup.id })}
        >
          {t("add_space")}
        </Dropdown.ItemWithLink>
        <Dropdown.ItemWithLink
          onClick={() =>
            addSpaceGroupMemberModal.show({ spaceGroupId: spaceGroup.id })
          }
        >
          {t("space_groups.add_members")}
        </Dropdown.ItemWithLink>
        <Dropdown.Separator />
        <Dropdown.ItemWithLink hasDanger onClick={toggleDeleteModal}>
          {t("space_groups.delete_space_group")}
        </Dropdown.ItemWithLink>
      </ThreeDotsDropdownV3>
    </>
  );
};
